import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import type {
  IHeader1,
  IHeader2,
  IHeader3,
  IHeader4,
  IHeader5,
  IHeader6,
  IHeader7,
  IHeader1046,
} from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createHeader(
  payload: Partial<
    | IHeader1
    | IHeader2
    | IHeader3
    | IHeader4
    | IHeader5
    | IHeader6
    | IHeader7
    | IHeader1046
  >,
) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.HEADER.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateHeader(
  id: number,
  payload: Partial<
    | IHeader1
    | IHeader2
    | IHeader3
    | IHeader4
    | IHeader5
    | IHeader6
    | IHeader7
    | IHeader1046
  >,
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.HEADER.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

